import { RootState } from '../../../applicationStore';
import { ResourcesState } from '../reducers';
import { createSelector } from '@reduxjs/toolkit';

export const getResourcesState = (state: RootState): ResourcesState =>
  state.resources;

export const getResourcesLoader = createSelector(
  getResourcesState,
  (state): boolean => state.loading,
);

export const getResourcesData = createSelector(
  getResourcesState,
  (state): ResourcesState['data'] | null => state?.data || [],
);
